/**
 * @method gets the Header object for api calls
 * @returns header object
 */
export const headersInstance = () => ({});
